export default {
  colors: {
    white: "#f8f8f2",
    lightGray: "#bbbabc",
    gray: "#777",
    black: "#222",
    default: "#333",
    primary: "#2d78bf",
    secondary: "#444",
    tertiary: "#555",
    quaternary: "#333",
    error: "#ff5555",
  },
  typography: {
    mainFont: "Open Sans",
    baseFont: "16px",
    colorFont: "#333",
    backColor: "#fff",
    bold: 700,
    normal: 400,
  },
  layout: {
    maxWidth: "1400px",
    mdWidth: "768px",
    smWidth: "600px",
    xsWidth: "480px",
  },
};
